import React from 'react';

// Standalone "install the manager app" page — send staff to /app.
// The APK is hosted separately on the server at /download/jgmanager.apk
// (upload it there via FTP; overwrite that file for future updates).
const APK_URL = '/download/jgmanager.apk';
const VERSION = '1.1';

const steps = [
  'Tap "Download for Android" below — the app file (.apk) saves to your phone.',
  'Open it (from the download notification, or Files → Downloads).',
  'Android will ask to "allow this source" — tap Settings and turn it on, then go back.',
  'Tap Install, then Open, and sign in with your manager account.',
];

export default function DownloadApp() {
  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.logo}>JG</div>
        <h1 style={s.title}>JG Detailing — Manager App</h1>
        <p style={s.sub}>Manage appointments, confirm bookings, and get new-booking alerts on your phone.</p>

        <a href={APK_URL} style={s.btn} download>⬇ Download for Android</a>
        <p style={s.ver}>Version {VERSION} · Android phones · ~37 MB</p>

        <div style={s.stepsBox}>
          <h2 style={s.stepsTitle}>How to install</h2>
          <ol style={s.ol}>
            {steps.map((t, i) => <li key={i} style={s.li}>{t}</li>)}
          </ol>
          <p style={s.note}>The "allow this source" prompt is normal for apps installed outside the Play Store — it's a one-time toggle.</p>
        </div>

        <p style={s.foot}>iPhone/iPad version coming soon. Trouble installing? Contact your admin.</p>
      </div>
    </div>
  );
}

const GOLD = '#c9a86a';
const s = {
  wrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: 'radial-gradient(900px 500px at 50% -10%, rgba(201,168,106,0.18), transparent 60%), #0a0b0e', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", boxSizing: 'border-box' },
  card: { width: '100%', maxWidth: 460, background: 'linear-gradient(180deg, #16181e, #121319)', border: '1px solid rgba(201,168,106,0.22)', borderRadius: 22, padding: 34, textAlign: 'center', color: '#f4f1ea', boxShadow: '0 30px 70px rgba(0,0,0,0.55)' },
  logo: { width: 66, height: 66, borderRadius: 18, background: GOLD, color: '#1c1505', fontWeight: 900, fontSize: 24, letterSpacing: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 18px' },
  title: { margin: '0 0 8px', fontSize: 23, fontWeight: 800, letterSpacing: 0.2 },
  sub: { margin: '0 0 24px', color: '#9b958a', fontSize: 14.5, lineHeight: 1.5 },
  btn: { display: 'block', background: `linear-gradient(145deg, ${GOLD}, #a8814c)`, color: '#1c1505', textDecoration: 'none', fontWeight: 800, fontSize: 17, padding: '15px 20px', borderRadius: 14, boxShadow: '0 12px 26px -6px rgba(201,168,106,0.5)' },
  ver: { color: '#6b665c', fontSize: 12.5, margin: '12px 0 0' },
  stepsBox: { textAlign: 'left', marginTop: 26, background: '#1c1f26', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 14, padding: '18px 20px' },
  stepsTitle: { margin: '0 0 12px', fontSize: 13, fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1, color: GOLD },
  ol: { margin: 0, paddingLeft: 20 },
  li: { fontSize: 14, lineHeight: 1.6, marginBottom: 8, color: '#e7e2d7' },
  note: { margin: '10px 0 0', fontSize: 12.5, color: '#9b958a', lineHeight: 1.5 },
  foot: { marginTop: 22, fontSize: 12.5, color: '#6b665c' },
};
